export const Positions = {
	Left: 'left',
	Right: 'right',
	Top: 'top',
	Bottom: 'bottom',
} as const;
